import React, { Component } from "react";
import Helping from '../../helpers/Helping';
import { connect } from "react-redux";
import Notification from "../layout/Notification";
import { getAll, removeNews, setNewsError } from "../../services/news.service";
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import Filter from "../layout/Filter";
import Pagination from "react-js-pagination";
import Modal from "../layout/Modal";
import CreateNews from "./Create";
import Service from "../../helpers/service";
import { API_URL } from '../../config/urls';
import { GET_NEWS, GET_LOOKUP } from '../../config/routes';
import { trackPromise } from "react-promise-tracker";
import { NEWS, MESSAGE, ROLE, ROUTE_ACCESS } from '../../config/index';

const { DELETE, NOT_FOUND, SYNC } = MESSAGE;
class List extends Component {
    constructor(props) {
        super(props);

        this.state = {
            news: {},
            url: API_URL.ADMIN_TRADING_API + GET_NEWS,
            count: '',
            routeName: '',
            error_message: '',
            error_type: '',
            btnIsEnable: false,
            isLoading: true,
            total: 0,
            activePage: 1,
            limit: NEWS.LIMIT,
            search: props.search,
            sorting: 'id',
            sort_type: 'DESC',
            platform: props.platform,
            id: '',
            edit_id: '',
            is_order: false,
            slideModal: false
        };

        this.deleteNews = this.deleteNews.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.pageRefreshFunction = this.pageRefreshFunction.bind(this);
        this.sortBy = this.sortBy.bind(this);
        this.closeEditModal = this.closeEditModal.bind(this);
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
        setNewsError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest(), ...Helping.clearModalRequest() });
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    componentDidMount() {
        const { pathname, error_message } = this.props.location;

        this.setState({
            routeName: pathname,
            error_message: error_message
        });

        this.setErrorOnApiCall();
        this.props.addCurrentRoute(this.props.profile, pathname);

        if (this.props.isLoading == true && this.props.news.length < 1) {
            this.getNews();
        }
    }

    getNews() {
        let search = this.state.search;

        this.props.getAll(this.state.activePage, this.state.limit,
            this.state.sorting, this.state.sort_type, search.trim(), this.state.platform);
    }

    handlePageChange(pageNumber) {
        if (this.props.page === pageNumber) {
            return false;
        }

        this.setState({
            activePage: pageNumber,
            isLoading: true
        }, () => {
            this.getNews();
        });
    }

    handleLimitChange(itemsLimit) {
        if (this.state.limit === itemsLimit) {
            return false;
        }
        this.setState({
            limit: itemsLimit,
            activePage: 1,
            isLoading: true
        }, () => {
            this.getNews();
            this.scrollToTop();
        });
    }

    openConfirmationModal = (e, object) => {
        this.setState({ id: object.id });
    }

    closeConfirmationModal = () => {
        window.$('#exampleDeleteModal').modal('hide');
        this.setState({
            id: ''
        });
    }

    openCreateModal = () => {
        this.setState({ edit_id: '', slideModal: true }, () => window.openSlideModal())
    }

    openEditModal = (e, object) => {
        this.setState({ edit_id: object.id, slideModal: true }, () => window.openSlideModal())
    }

    closeEditModal() {
        this.setState({
            edit_id: '',
            id: '',
            slideModal: false
        },
            () => window.closeSlideModal())
    }

    deleteNews() {
        this.setState({
            btnIsEnable: true
        });
        let $this = this;

        let data = {
            action: "remove",
            id: $this.state.id
        }

        Service.postCall($this.state.url, data).then(response => {
            $this.props.removeNews($this.state.id);

            $this.setState({
                error_message: Helping.getMessageString(DELETE, "news"),
                error_type: 'success',
                btnIsEnable: false
            }, () => { this.closeConfirmationModal(); this.scrollToTop(); });
        })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        btnIsEnable: false
                    }, () => { this.closeConfirmationModal(); this.scrollToTop(); });
                }
                return this.setState({
                    btnIsEnable: false,
                    ...Helping.setNetworkRequestError(error, "news deletion")
                }, () => { this.closeConfirmationModal(); this.scrollToTop(); })
            });
    }

    handleSearchChange(e) {
        let $this = this,
            searchValue = e.target.value.replace(/^\s+/g, '');

        if (this.state.search !== searchValue) {
            this.setState({
                search: searchValue,
                activePage: 1
            }, () => {
                if (searchValue.length > 0) {
                    $this.getNews();
                }

                if (searchValue.length === 0) {
                    $this.getNews();
                }
            });
        }
    }

    pageRefreshFunction(e) {
        e.preventDefault();

        this.setState({
            search: "",
            platform: "",
            activePage: 1,
            error_message: "",
            error_type: ""
        },
            () => this.getNews()
        );
    }

    sortBy(key) {
        let $this = this;
        let sortType = this.state.sort_type;

        if (this.state.sort_type === 'ASC') {
            sortType = 'DESC';
        }

        if (this.state.sort_type === 'DESC') {
            sortType = 'ASC';
        }

        this.setState({
            sorting: key,
            activePage: 1,
            is_order: true,
            sort_type: sortType
        }, () => {
            $this.removeNetworkError(); $this.getNews();
        });
    }

    syncAllLookups = () => {
        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + GET_LOOKUP, { action: 'sync-all' })
                .then(response => {
                    return this.setState({
                        error_message: Helping.getMessageString(SYNC, "Lookups"),
                        error_type: 'success'
                    }, () => this.scrollToTop());
                })
                .catch(error => {
                    console.log({ error });
                    if (error.response) {
                        Helping.redirectToLogin(error);

                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger'
                        }, () => this.scrollToTop());
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "lookups")
                    }, () => this.scrollToTop());
                })
        )
    }

    filteredResults = (e) => {
        e.preventDefault();
        this.setState({
            activePage: 1
        }, () => this.getNews())
    }

    render() {
        let role_access = {}, isAdmin = false;
        const filtersArray = [this.props.platform],
            data = {
                inputs: [{
                    type: 'dropdown',
                    label: 'Platform',
                    name: 'platform',
                    defaultValue: this.state.platform,
                    placeholder: 'Select Platform...',
                    data: [{ "name": 'all', "value": 'all' }, { "name": 'web', "value": 'web' }, { "name": 'mobile', "value": 'mobile' }]
                }],
                handleValueChange: (e) => this.setState({ platform: e.target.value }),
                reset: this.pageRefreshFunction,
                getResults: this.filteredResults
            }

        if (Object.keys(this.props.profile).length > 0) {
            role_access = JSON.parse(this.props.profile.role_access);
            isAdmin = role_access.role === ROLE.ADMIN.toLowerCase();
        }
        let writeAccess = isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.NEWS.toLowerCase()].write);

        return (
            <>
                {writeAccess &&
                    <>
                        {this.state.slideModal &&
                            <CreateNews id={this.state.edit_id} closeEditModal={this.closeEditModal} />
                        }
                        <Modal msg="news" onDelete={this.deleteNews} btnIsEnable={this.state.btnIsEnable} />
                    </>
                }
                <div class="content category-list">
                    <div class="top-header">
                        <div class="header-title">
                            <h2 class="title">News</h2>
                            <span class="title-caption">You have total {this.props.total} news</span>

                            {/*  SEARCH BAR  */}
                            <form class="listing-search-form" onSubmit={(e) => e.preventDefault()}>
                                <span class="search-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999">
                                        <path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)" />
                                    </svg>
                                </span>
                                <input class="form-control" type="search" placeholder="Search in News" aria-label="Search" value={this.state.search} onChange={(e) => this.handleSearchChange(e)} />
                            </form>
                            {/*  SEARCH BAR END  */}
                        </div>

                        <div class="header-btn">
                            <button class="custom-btn icon-btn dark-btn sm-btn" title="Sync Lookups" onClick={this.syncAllLookups}>
                                <svg id="noun_Refresh_2846824" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                    <g id="Group_135" data-name="Group 135" transform="translate(1.124 13.085)">
                                        <g id="Group_134" data-name="Group 134" transform="translate(0)"><path id="Path_388" data-name="Path 388" d="M105.3,663.5c-.551,0-1.1,0-1.65,0l-2.618,0h-.6a1.039,1.039,0,0,0-1.023,1.023c0,.551,0,1.1,0,1.65q0,1.308,0,2.616v.6a1.065,1.065,0,0,0,.3.725,1.028,1.028,0,0,0,1.449,0,1.062,1.062,0,0,0,.3-.725c0-.551,0-1.1,0-1.65q0-1.308,0-2.616v-.6l-1.023,1.023c.551,0,1.1,0,1.65,0l2.618,0h.6a1.065,1.065,0,0,0,.725-.3,1.028,1.028,0,0,0,0-1.449,1.079,1.079,0,0,0-.725-.3Z" transform="translate(-99.4 -663.5)"></path></g></g><g id="Group_137" data-name="Group 137" transform="translate(10.033)">
                                        <g id="Group_136" data-name="Group 136" transform="translate(0 0)"><path id="Path_389" data-name="Path 389" d="M591.186,29.573c.551,0,1.1,0,1.65,0l2.618,0h.6a1.039,1.039,0,0,0,1.023-1.023c0-.551,0-1.1,0-1.65q0-1.308,0-2.616v-.6a1.065,1.065,0,0,0-.3-.725,1.028,1.028,0,0,0-1.449,0,1.061,1.061,0,0,0-.3.725c0,.551,0,1.1,0,1.65q0,1.308,0,2.616v.6l1.023-1.023c-.551,0-1.1,0-1.65,0l-2.618,0h-.6a1.065,1.065,0,0,0-.725.3,1.028,1.028,0,0,0,0,1.449,1.071,1.071,0,0,0,.725.3Z" transform="translate(-590.162 -22.662)"></path></g></g><g id="Group_139" data-name="Group 139" transform="translate(1.146 8.949)"><g id="Group_138" data-name="Group 138" transform="translate(0)"><path id="Path_390" data-name="Path 390" d="M115.414,462.488a9.114,9.114,0,0,1-.071,1.144l.035-.272a9,9,0,0,1-.556,2.178c.033-.082.065-.164.1-.244a8.787,8.787,0,0,1-1.03,1.883l.15-.207a8.381,8.381,0,0,1-1.454,1.552l.194-.16a7.986,7.986,0,0,1-1.764,1.1l.228-.1a7.614,7.614,0,0,1-2.04.594l.255-.037a7.612,7.612,0,0,1-2.146,0l.255.037a7.67,7.67,0,0,1-2.017-.587l.228.1a8.028,8.028,0,0,1-1.789-1.118l.194.16a8.446,8.446,0,0,1-1.434-1.535l.15.207a8.735,8.735,0,0,1-.64-1.032,1,1,0,0,0-.573-.471.927.927,0,0,0-.738.1,1.025,1.025,0,0,0-.441.612,1.155,1.155,0,0,0,.1.788,9.393,9.393,0,0,0,3.312,3.576,8.463,8.463,0,0,0,8.974-.012,9.355,9.355,0,0,0,3.1-3.218,10.08,10.08,0,0,0,1.331-4.544c.01-.166.013-.33.013-.5a1.1,1.1,0,0,0-.28-.725.92.92,0,0,0-1.358,0,1.14,1.14,0,0,0-.276.727Z" transform="translate(-100.474 -461.462)"></path></g></g><g id="Group_141" data-name="Group 141" transform="translate(0 0.473)"><g id="Group_140" data-name="Group 140" transform="translate(0 0)"><path id="Path_391" data-name="Path 391" d="M46.415,55.283a9.36,9.36,0,0,1,.071-1.136l-.035.272a9.031,9.031,0,0,1,.558-2.178c-.033.082-.065.164-.1.244A8.73,8.73,0,0,1,47.946,50.6l-.15.207a8.368,8.368,0,0,1,1.453-1.549l-.194.16a7.984,7.984,0,0,1,1.764-1.1l-.228.1a7.612,7.612,0,0,1,2.04-.594l-.255.037a7.687,7.687,0,0,1,2.146,0l-.255-.037a7.72,7.72,0,0,1,2.021.59l-.228-.1a7.981,7.981,0,0,1,1.768,1.1l-.194-.16a8.342,8.342,0,0,1,1.44,1.535l-.15-.207a8.593,8.593,0,0,1,.615.98,1,1,0,0,0,.573.471.927.927,0,0,0,.738-.1,1.024,1.024,0,0,0,.441-.612,1.143,1.143,0,0,0-.1-.788A9.336,9.336,0,0,0,57.876,47a8.464,8.464,0,0,0-8.931.037,9.366,9.366,0,0,0-3.085,3.193,10.056,10.056,0,0,0-1.342,4.505c-.012.182-.015.362-.017.544a1.1,1.1,0,0,0,.28.725.92.92,0,0,0,1.357,0,1.118,1.118,0,0,0,.278-.725Z" transform="translate(-44.5 -45.747)"></path></g>
                                    </g>
                                </svg>
                                <span class="txt-btn">Sync Lookups</span>
                            </button>

                            <Filter data={data} classes={filtersArray.filter(arr => arr != "").length > 0 ? "filtered" : ""} />

                            <button class="custom-btn icon-btn dark-btn sm-btn" onClick={this.pageRefreshFunction}>
                                <svg id="refresh" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                    <path id="Path_449" data-name="Path 449" d="M313.164,391.557c-.048-.293-.092-.582-.142-.871a1.127,1.127,0,0,1,.858-1.384,1.064,1.064,0,0,1,1.23.963q.326,1.894.628,3.794a1.1,1.1,0,0,1-.933,1.327l-3.615.643a1.065,1.065,0,0,1-1.262-.888,1.1,1.1,0,0,1,.854-1.288c.438-.095.882-.163,1.378-.252-.108-.068-.173-.113-.242-.151a6.869,6.869,0,0,0-10.015,5.356,7.187,7.187,0,0,0,5.554,8.138,6.961,6.961,0,0,0,8.137-5.977,1.081,1.081,0,0,1,1-.984,1.024,1.024,0,0,1,1.063.8,2.485,2.485,0,0,1-.027.9,9.223,9.223,0,0,1-7.31,7.461,9.074,9.074,0,0,1-10.447-7.421,9.412,9.412,0,0,1,7.2-11.144,8.62,8.62,0,0,1,5.859.9c.053.028.1.056.158.082A.241.241,0,0,0,313.164,391.557Z" transform="translate(-299.689 -389.283)" />
                                </svg>
                                <span class="txt-btn">Refresh</span>
                            </button>

                            {writeAccess &&
                                <button class="custom-btn gradiant-btn sm-btn" id="addButton" onClick={() => this.openCreateModal()}>Add News</button>
                            }
                        </div>
                    </div>

                    <div class="main-content">
                        {this.state.error_message &&
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                                callback={this.removeNetworkError}
                            />
                        }
                        <div class="user-listing-tbl table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('id')}>
                                            ID
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('title')}>
                                            Title
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'title' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'title' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="text-center" scope="col">Cover Image</th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('platform')}>
                                            Platform
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'platform' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'platform' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Description</th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('created_at')}>
                                            Date Created
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'created_at' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'created_at' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        {writeAccess &&
                                            <th scope="col">Actions</th>
                                        }
                                    </tr>
                                </thead>

                                {(this.props.total > 0 && !this.props.isLoading) && (
                                    <tbody>
                                        {this.props.news.map((object, i) => (
                                            <tr key={i}>
                                                <td scope="row">{object.id}</td>
                                                <td><div class="truncate">{object.title}</div></td>
                                                <td>
                                                    <div class="newsCoverImg">
                                                        <img src={object.imageUrl ? object.imageUrl : null} alt="News Image" class="img-fluid" />

                                                    </div>
                                                </td>
                                                <td class="platform">{object.platform ? object.platform : ""}</td>
                                                <td>{object.status ? Helping.getTitleCase(object.status) : ""}</td>
                                                <td>
                                                    <div class="news-detail truncate">{object.description}</div>
                                                </td>
                                                <td><div class=" ">{Helping.convertTimeToHumanReadableFormat(object.created_at)}</div></td>
                                                {writeAccess && (
                                                    <td>
                                                        <div className="action-links">
                                                            <button type="button" class="icon edit" onClick={(e) => this.openEditModal(e, object)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                    <path id="edit" d="M17,2a1.02,1.02,0,0,0-.719.281l-2,2-8,8A1.02,1.02,0,0,0,6,13v4a1,1,0,0,0,1,1h4a1.02,1.02,0,0,0,.719-.281l8-8,2-2A1.02,1.02,0,0,0,22,7a4.944,4.944,0,0,0-1.281-3.687A4.849,4.849,0,0,0,17,2Zm.375,2.063a2.753,2.753,0,0,1,1.906.625,2.92,2.92,0,0,1,.656,1.937L19,7.563,16.437,5ZM15,6.438,17.562,9l-7,7H8V13.438ZM10,4a1,1,0,0,1,0,2H6A2,2,0,0,0,4,8V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V14a1,1,0,0,1,2,0v4a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4Z" transform="translate(-2 -2)" />
                                                                </svg>
                                                            </button>

                                                            <button
                                                                type='button'
                                                                class="icon delete"
                                                                data-toggle="modal" data-target="#exampleDeleteModal" onClick={(e) => this.openConfirmationModal(e, object)}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                                                    <path id="delete" d="M11.073,11.953V16.93a1,1,0,0,1-2,0V11.953a1,1,0,0,1,2,0Zm3-.995a1,1,0,0,0-1,.995V16.93a1,1,0,0,0,2,0V11.953A1,1,0,0,0,14.073,10.958Zm-8-.032a1,1,0,0,0-1,1v6a3.959,3.959,0,0,0,3.969,3.95l6.031.031a3.955,3.955,0,0,0,3.969-3.95v-6a1,1,0,0,0-2,0v6a1.964,1.964,0,0,1-1.969,1.96l-6.031-.032a1.96,1.96,0,0,1-1.969-1.959v-6A1,1,0,0,0,6.073,10.926Zm15-5.07V7.972a1,1,0,0,1-1,.995h-16a1,1,0,0,1-1-.995v-1.9A3.972,3.972,0,0,1,7.011,2.093L17.1,1.906A3.959,3.959,0,0,1,21.073,5.856ZM7.042,4.084a1.989,1.989,0,0,0-1.969,1.99v.9h14V5.856A1.95,1.95,0,0,0,17.135,3.9Z" transform="translate(-3.073 -1.906)" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                            </table>
                        </div>

                        {this.props.total > 0 && (
                            <div class="table-bottom">
                                <div class="dataTables_length">
                                    <label>Show
                                        <select
                                            name="userDataTable_length"
                                            value={this.props.limit}
                                            onChange={(e) => this.handleLimitChange(e.target.value)}
                                        >
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select> of {this.props.total}</label>
                                </div>
                                <Pagination
                                    // hideFirstLastPages
                                    activePage={this.props.page}
                                    itemsCountPerPage={this.props.limit}
                                    totalItemsCount={this.props.total}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange}
                                    itemClass='page-item'
                                    linkClass='page-link'
                                    prevPageText='Pre'
                                    nextPageText='Next'
                                    firstPageText='First'
                                    lastPageText='Last'
                                    innerClass="dataTables_paginate"
                                    linkClass="paginate_button"
                                    activeLinkClass="paginate_button current"
                                    disabledClass="paginate_button disabled"
                                />
                            </div>
                        )}

                        {(this.props.total < 1 && !this.props.isLoading) && (
                            <div class="user-listing-tbl table-responsive">
                                <Notification
                                    type='danger'
                                    message={Helping.getMessageString(NOT_FOUND, 'news')}
                                    callback={this.removeNetworkError}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        news: state.news,
        profile: state.profile,
        total: state.fetchNewsMeta.total,
        isLoading: state.fetchNewsMeta.isLoading,
        page: state.fetchNewsMeta.page,
        search: state.fetchNewsMeta.search,
        platform: state.fetchNewsMeta.platform,
        limit: state.fetchNewsMeta.limit,
        no_Of_pages: state.fetchNewsMeta.no_Of_pages
    }
}

const mapDispatchToProps = {
    getAll,
    removeNews,
    addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(List)